Object.defineProperty(exports, '__esModule', { value: true });

const handleDom = require('./handleDom.js');
const handleScope = require('./handleScope.js');

/**
 * An event handler to react to breadcrumbs.
 */
function breadcrumbHandler(type, handlerData) {
  if (type === 'scope') {
    return handleScope.handleScope(handlerData );
  }

  return handleDom.handleDom(handlerData );
}

exports.breadcrumbHandler = breadcrumbHandler;
//# sourceMappingURL=breadcrumbHandler.js.map
